import {envAwarePost} from '../util/util'
import {useState} from 'react'
import isImage from 'is-image'
import { readAndCompressImage } from 'browser-image-resizer'
import imageCompression from 'browser-image-compression'

/*-----------------------------------

Hook that facilitates the Upload flow documented here:
- https://fitsw.atlassian.net/wiki/spaces/FITSW/pages/445284356/Upload+API

Returns destructurable object for easy integration into Components

-----------------------------------*/

const alertError = () => {
	window.alert('There was an error saving the attached document. Please, try again.')
}

const uploadToS3 = async (file, signed_url) => {
	if (file.size > 40000000) {
		window.alert('The max file size is 40MB')
		return
	}
	return fetch(signed_url,{
		method:'PUT',
		body:file
	})
}

const cleanFailedUpload = (upload_id) => {
	envAwarePost('api/uploads/api/',{
		action:'cleanFailedUpload',
		upload_id
	})
}

/*
	Pass in object of form 
	{
		success:<function>,
		fail:<function>
	}
	success is a callback to fire when the upload process succeeds
	fail is a callback to fire if the upload fails somewhere

	Observe: input is destructured
*/

const formatResponse = (success,payload)=>({success,payload})

const useDirectUpload = ()=>{
	//file to be upload
	const [file,setFile] = useState(null)
	//handler for uploading
	const processUpload = async (upload)=>{
		//since some logic doesn't work with setUpload
		//allow passing an upload directly
		upload = upload || file
		//retrive signed url from our server

		let fileName = upload?.name.split('.')[0];

		const apiRes = await envAwarePost('api/uploads/api/',{
			action:'getSignedUrl',
			file_name : fileName === "customLogo" ? fileName : null,
			file_extension: upload?.name.split('.').pop()
		})
		//handle failed messing from our server
		if(apiRes.success === '0'){
			return formatResponse(false,null)
		}else{
			//pull data from response
			const {signed_url,upload_id,url} = apiRes.data
			//upload file to s4
			const s3Res = await uploadToS3(upload,signed_url)
			if(s3Res.status === 200){
				return formatResponse(true,{url,upload_id})
			}else{
				cleanFailedUpload(upload_id)
				return formatResponse(false,null)
			}
		}
	}
	//wrap some local state calls in a helper
	const clearUpload = ()=>{
		setFile(null)
	}
	//wrap some local state calls in a helper
	//if(file) is here since input onchange events 
	//will be fired if no file is selected resulting
	//in undesired state changes. ie we only want to 
	//modify the local state if there is actually a file
	const setUpload = (file)=>{

		if(file){
			setFile(file)
		}
	}
	//expose needed variables and functions 
	return {file,processUpload,setUpload,clearUpload}
}

export default useDirectUpload